// extracted by mini-css-extract-plugin
export default {"imageBottom":"HeaderBottom_imageBottom__DVFxL"};